export default {
  API_URL: "https://api.acrosstech.cloud/cts-public",
  //API_URL: 'https://cts-api.herokuapp.com'
};
